import {I18n, MessageProvider, TProvider} from '../../i18n/i18n';
import React from 'react';
import {classes, stylesheet} from 'typestyle';
import {ReportEditing} from '../types/Report';
import {ReportError} from '../stores/ReportEditorStore';
import {LoadingHover} from '../../views/Legend/TermItem';
import {BlackColor, LightGreyColor, BlueColor, WhiteColor, GreyColor, Shadow2} from '../../styles/colors';

interface LeftSidebarActionsProps {
    closeEditor: () => void;
    saveReport: () => void;
    reportEditing: ReportEditing;
    closeErrorBox: () => void;
    togglePreviewMode: () => void;
    previewModeEnabled: boolean;
    isSaving: boolean;
}

export default class LeftSidebarActions extends React.Component<LeftSidebarActionsProps> {
    private closeErrorBox = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.closeErrorBox();
    };

    private getErrorMessage = (reportError: ReportError, t: MessageProvider): {errorTitle: string; errorMessage: string} => {
        switch (reportError) {
            case ReportError.ReportEmpty:
                return {errorTitle: t('report:reportIsEmpty'), errorMessage: t('report:pleaseUseAndDefineReportBuildingBlocks')};
            case ReportError.ProductAndSearchDataMixed:
                return {errorTitle: t('report:searchProductMixed'), errorMessage: t('report:searchAndProductItemsShouldNotBeMixedInMemoryItem')};
            case ReportError.ReportNameAlreadyUsed:
                return {errorTitle: t('report:reportNameAlreadyUsed'), errorMessage: t('report:reportNameAlreadyUsedByOtherReport')};
            case ReportError.ReportNameMissing:
                return {errorTitle: t('report:missingReportName'), errorMessage: t('report:reportNameIsNotSpecified')};
            default:
                throw Error('Unknown reportError ' + reportError);
        }
    };

    private renderSaveErrorMessage = (t: MessageProvider) => {
        const {errors} = this.props.reportEditing;
        if (errors.length > 0) {
            const {errorTitle, errorMessage} = this.getErrorMessage(errors[0], t);
            return (
                <div className={actionCss.saveErrorBox} onClick={this.closeErrorBox}>
                    <div className={actionCss.saveErrorTitle}>{errorTitle}</div>
                    <div>{errorMessage}</div>
                </div>
            );
        }
        return null;
    };

    public render() {
        const {closeEditor, saveReport} = this.props;

        return (
            <div>
                <div className={classes(actionCss.actionLineContainer, 'noBottomPadding')}>
                    <button className={actionCss.abortButton} onClick={this.props.togglePreviewMode}>
                        {this.props.previewModeEnabled ? <I18n i18nKey="report:disablePreviewMode" /> : <I18n i18nKey="report:enablePreviewMode" />}
                    </button>
                </div>
                <div className={actionCss.actionLineContainer}>
                    <button onClick={closeEditor} className={actionCss.abortButton}>
                        <I18n i18nKey="data.abort" />
                    </button>
                    <button className={actionCss.saveButton} onClick={() => saveReport()}>
                        <TProvider>{(t) => this.renderSaveErrorMessage(t)}</TProvider>
                        {this.props.isSaving ? <LoadingHover /> : null}
                        <I18n i18nKey="data.save" />
                    </button>
                </div>
            </div>
        );
    }
}

const actionCss = stylesheet({
    loadingSpinner: {
        position: 'absolute',
        width: '100%',
        height: '100%',
    },
    abortButton: {
        position: 'relative',
        flex: 1,
        overflow: 'hidden',
        borderRadius: 2,
        backgroundColor: BlueColor,
        border: 'none',
        color: WhiteColor,
        padding: 5,
    },
    saveButton: {
        borderRadius: 2,
        flex: 1,
        color: WhiteColor,
        position: 'relative',
        marginLeft: 10,
        border: 'none',
        backgroundColor: 'yellowGreen',
        padding: 5,
    },
    actionLineContainer: {
        display: 'flex',
        backgroundColor: WhiteColor,
        padding: 10,
        position: 'relative',
        $nest: {
            '&.noBottomPadding': {
                paddingBottom: 0,
            },
        },
    },
    saveErrorTitle: {
        fontSize: 12,
        fontWeight: 'bold',
    },
    saveErrorBox: {
        color: BlackColor,
        cursor: 'pointer',
        textAlign: 'left',
        padding: 15,
        position: 'absolute',
        borderRadius: 2,
        backgroundColor: WhiteColor,
        border: '1px solid ' + LightGreyColor,
        boxShadow: Shadow2,
        bottom: 48,
        right: 0,
        width: 300,
        $nest: {
            '&:after, &:before': {
                top: '100%',
                right: 13,
                border: 'solid transparent',
                content: '" "',
                height: 0,
                width: 0,
                position: 'absolute',
                pointerEvents: 'none',
            },
            '&:after': {
                borderTopColor: WhiteColor,
                borderWidth: 10,
                marginLeft: -10,
            },
            '&:before': {
                borderTopColor: GreyColor,
                borderWidth: 11,
                marginLeft: -11,
            },
        },
    },
});



// WEBPACK FOOTER //
// ./src/report/views/LeftSidebarActions.tsx